module.exports = __webpack_public_path__ + "img/ScaledAccess-Blog-Video-Icon.svg";